<template>
	<div class="p-mb-6">
		<p>
			<b
				>{{ question }}
				<div class="tooltip">
					<Button
						icon="pi pi-cloud-download"
						@click="isShowDialog = true"
						class="p-button-secondary p-button-text animated-border"
					/>
					<span class="tooltiptext">Export to Excel</span>
				</div>
			</b>
		</p>
		<table class="p-fluid" style="width: 100%" v-if="value.headers.length > 0">
			<thead class="p-fluid-thead">
				<tr>
					<th v-for="(thead, index) in value.headers" :key="index">
						<div class="th_container">
							<div class="name">
								{{ thead.label }}
							</div>
						</div>
					</th>
					<th v-if="ifEdit">
						<div style="width: 160px">
							<Button
								class="p-button-raised p-button-text"
								icon="pi pi-arrow-down"
								@click="addNewRow()"
								style="background-color: white"
							/>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, index) in value.rows" :key="index">
					<td v-for="thead of value.headers" :key="thead.label">
						<Textarea
							type="text"
							:value="row[thead.label]"
							:ref="index"
							:autoResize="true"
							@change="handleCellChange(row, thead.label, $event.target.value)"
							:style="{
								color: row[thead.label] === 'X' ? 'red' : '',
								'font-style': row[thead.label] === 'X' ? 'italic' : '',
								'font-size': row[thead.label] === 'X' ? '21px' : '',
								'align-content': row[thead.label] === 'X' ? 'center' : '',
								'padding-left': row[thead.label] === 'X' ? '45%' : '',
								'font-weight': row[thead.label] === 'X' ? 'bold' : ''
							}"
						/>
					</td>
				</tr>
			</tbody>
		</table>
		<Dialog header="Export to Excel" :visible.sync="isShowDialog" :modal="true">
			<!-- :style="{ width: '450px' }" -->

			<div class="p-inputgroup">
				<span class="p-inputgroup-addon">NewFile-Name:</span>
				<InputText
					placeholder="e.g.ParticipantTimeline.xlsx"
					v-model="fileName"
				/>
			</div>

			<template #footer>
				<Button
					label="Cancel"
					icon="pi pi-times"
					class="p-button-text"
					@click="isShowDialog = false"
				/>
				<Button
					label="Confirm"
					icon="pi pi-check"
					class="p-button-text"
					@click="generateExcel(value.headers, value.rows, fileName)"
				/>
			</template>
		</Dialog>
	</div>
</template>
<script>
import Textarea from "primevue/textarea";
import Button from "primevue/button";
import ExcelJS from "exceljs";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";
Vue.use(VueExcelEditor);
// import * as XLSX from "xlsx";
export default {
	name: "InputPTTableCustom",
	components: {
		Textarea,
		Button,
		Dialog,
		InputText
	},
	props: {
		question: String,
		value: {}
	},
	data() {
		return {
			ifEdit: false,
			show: false,
			isShowDialog: false,
			fileName: "",
			methodsUrl: "",
			toolLinkName: "",
			people: [],
			selectedRowIndex: -1, // Initialize with -1 (no selection)
			selectedColumnIndex: -1 // Initialize with -1 (no selection)
		};
	},
	methods: {
		changeHandler(event) {
			if (event != undefined) {
				this.$emit("values", this.value);
			}
		},
		handleCellChange(row, field, newValue) {
			const finalValue = newValue == "x" ? newValue.toUpperCase() : newValue;
			this.$set(row, field, finalValue);
			this.changeHandler(finalValue);
		},
		addRow(index, optionNum) {
			let row = {};
			for (var i = 0; i < this.value.headers.length; i++) {
				// row[this.value.headers[i].label] = '';
				this.$set(row, row[this.value.headers[i].label]);
			}
			if (optionNum == 0) {
				this.value.rows.splice(index, 0, row);
			} else {
				this.value.rows.splice(index + 1, 0, row);
			}
			this.$emit("values", this.value);
		},
		addNewRow() {
			const newRow = {};
			for (const header of this.value.headers) {
				newRow[header.label] = ""; // Initialize new row with empty values
			}
			this.value.rows.push(newRow);
			// console.log("New row added", this.value);
			// debugger;
			// Vue.set(this.value.rows, this.value.rows.length, newRow);
			this.$emit("values", this.value);
			// console.log("placed", this.value);
		},
		deleteRow(index) {
			this.value.rows.splice(index, 1);
			this.$emit("values", this.value);
		},
		moveRowUp(index) {
			if (index > 0) {
				const movedRow = this.value.rows.splice(index, 1)[0];
				this.value.rows.splice(index - 1, 0, movedRow);
				this.$emit("values", this.value);
			}
		},

		moveRowDown(index) {
			if (index < this.value.rows.length - 1) {
				const movedRow = this.value.rows.splice(index, 1)[0];
				this.value.rows.splice(index + 1, 0, movedRow);
				this.$emit("values", this.value);
			}
		},
		generateExcel(samples, rows, filename) {
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet("Sheet 1");

			// Create headers
			const headers = samples.map(header => header.label);
			worksheet.addRow(headers).font = { bold: true }; // Add header row and make it bold

			// Initialize column widths
			const columnWidths = headers.map(header => header.length);

			// Add data rows and update column widths
			rows.forEach(row => {
				const rowData = samples.map(header => row[header.label] || "");
				const newRow = worksheet.addRow(rowData);
				// worksheet.addRow(rowData);

				// Update column widths based on the length of data in each cell
				rowData.forEach((cellData, colIndex) => {
					const cell = newRow.getCell(colIndex + 1);
					if (cellData === "X") {
						cell.font = {
							color: { argb: "FF0000" },
							italic: true,
							bold: true
						};
					}
					const cellDataLength = String(cellData).length;
					if (cellDataLength > columnWidths[colIndex]) {
						columnWidths[colIndex] = cellDataLength;
					}
				});
			});

			// Set column widths
			headers.forEach((_, index) => {
				worksheet.getColumn(index + 1).width = Math.max(
					10,
					columnWidths[index] + 2
				);
			});

			// Apply alternating colors to header row
			headers.forEach((_, index) => {
				const isEvenColumn = index % 2 === 0;
				const cell = worksheet.getCell(1, index + 1);
				if (isEvenColumn) {
					cell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "fceddd" }
					};
				} else {
					cell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "f6c897" }
					};
				}
			});

			// Generate Excel file
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], {
					type:
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				});

				// Create a download link and trigger the download
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				if (filename != "") {
					link.download = filename + ".xlsx";
				} else {
					link.download = "ParticipantTimeline.xlsx";
				}
				link.click();
			});
			this.isShowDialog = false;
		},

		handleCellClick(row, columnIndex) {
			// Remove the custom classes from previously clicked cells
			console.log("cell clicked", row, columnIndex);
			this.selectedRowIndex = row.rowPos;
			this.selectedColumnIndex = row.colPos;
			const cells = document.querySelectorAll(".bold-cell, .italic-cell");
			cells.forEach(cell => {
				cell.classList.remove("bold-cell", "italic-cell");
			});

			// Apply the custom class to the clicked cell
			const clickedCell = document.querySelector(
				`[data-row="${this.selectedRowIndex}"][data-col="${this.selectedColumnIndex}"]`
			);

			if (clickedCell) {
				clickedCell.classList.add("bold-cell");
			}
		},
		delRecord(array) {
			console.log("Dete row information", array);
			// this.$refs.grid.deleteRecord(0) // delete the 1st record
		}
	},
	watch: {
		value: function(val) {
			console.log("magicccc value", val);
		}
	}
};
</script>
<style scoped>
.bold-cell {
	font-weight: bold;
}

.italic-cell {
	font-style: italic;
}

table {
	border-collapse: collapse;
	display: block;
	overflow: auto;
	overflow-x: auto;
	border: none !important;
	/*background-color: rgba(240, 240, 240, 0.73);*/
}

.p-togglebutton.p-button {
	background: rgba(72, 90, 120, 0.824);
	border: transparent;
	height: 20px;
}

.p-button-text {
	height: 20px;
}

.p-fluid-thead {
	position: sticky;
	top: 0px;
	background-color: white;
	border: 1px solid black;
	z-index: 10;
	height: 80px;
}

.p-fluid .p-inputtextarea {
	border-style: none;
}

.th_container {
	/*display: inline-block;*/
	display: flex;
	position: relative;
	height: 30px;
	width: 250px;
}

.name {
	/*float: left;*/
	/*flex: 4;*/
	position: absolute;
	left: 30%;
	top: 20%;
	font-size: 18px;
	z-index: 10;
}

.menu {
	/*float: right;*/
	position: absolute;
	left: 68%;
	top: 20%;
}

.btnArea {
	position: sticky;
	right: 0px;
	top: 30px;
	background-color: transparent;
}

.inline-input {
	height: 40px;
}

th,
td {
	border: 1px solid black;
}

/* Tooltip container */
.tooltip {
	position: relative;
	display: inline-block;
	/* border-bottom: 1px dotted black; */
}

/* Tooltip text */
.tooltip .tooltiptext {
	visibility: hidden;
	width: 120px;
	background-color: #475c8d;
	color: #fff;
	text-align: center;
	padding: 6px;
	border-radius: 6px;
	font-size: 12px;

	/* Position the tooltip text - see examples below! */
	position: absolute;
	z-index: 1;
	/* transition */
	opacity: 0;
	transition: opacity 1s;
}

.tooltip .tooltiptext::after {
	content: "";
	position: absolute;
	top: 50%;
	right: 100%;
	margin-top: -5px;
	border-width: 5px;
	border-style: solid;
	border-color: transparent #475c8d transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
	visibility: visible;
	/* transition */
	opacity: 1;
}

.animated-border {
	position: relative;
	/* display: inline-block; */
	padding: 10px 20px;
	border: 2px solid transparent;
	/* background: linear-gradient(white, white) padding-box, 
                linear-gradient(to right, #42a5f5 25%, transparent 25%, transparent 50%, #42a5f5 50%, #42a5f5 75%, transparent 75%) border-box; */
	background: linear-gradient(white, #e9f0fb) padding-box,
		linear-gradient(
				to right,
				#89b7dd 25%,
				transparent 25%,
				#9e99eb 50%,
				#42a5f5 50%,
				#567e9f 75%,
				#a3bdd1 75%
			)
			border-box;
	background-size: 200% 200%;
	background-position: 100% 100%;
	animation: moveBorder 4s linear infinite;
	transition: background 0.3s;
	border-radius: 5px;
	/* Optional: Adds rounded corners */
}

@keyframes moveBorder {
	0% {
		background-position: 0% 0%;
	}

	100% {
		background-position: 100% 100%;
	}
}

.animated-border:hover {
	background-size: 300% 300%;
	/* Makes the animation more noticeable on hover */
}
</style>
